import { initMap } from "./_map";

const block = document.querySelector('section.text-and-map');

document.addEventListener('DOMContentLoaded', function () {
    if(block) {
        initMap();
    }  
}, false);